import React, { useState } from 'react'
import { AntTabs, AntTab } from './common/Tabs'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import { resourceCompensationCols, resourceCompensationOtherCols } from '../constants/ResourceCols'

const tabs = [
  { display: 'Main', value: 0 },
  { display: 'Other Pay Rates', value: 1 }
]

export default function ResourceCompensation(props) {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='compensation tabs'
      >
        {tabs.map((cur, index) => (
          <AntTab
            key={index}
            label={cur.display}
            value={cur.value}
            color={props.fetchInitialData.credentials.primaryAppColor}
          />
        ))}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`compensation-${props.tableRefreshKey}`}
            params={{ ...props.headers }}
            tableColumns={resourceCompensationCols}
            reportName='hr_resource_compensation'
          />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`compensation-other-${props.tableRefreshKey}`}
            params={{ ...props.headers }}
            tableColumns={resourceCompensationOtherCols}
            reportName='hr_resource_compensation_other'
          />
        </div>
      )}
    </>
  )
}
